
import LoginReducer from './LoginReducer';
import { combineReducers } from 'redux';
import TrailerManagementReducer from './TrailerManagementReducer';
import UserManagementReducer from './UserManagementReducer';
import DoorReducer from './DoorReducer';
import DivisionReducer from './DivisionReducer';
import LotReducer from './LotReducer';
import DriverReducer from './DriverReducer';
import TruckReducer from './TruckReducer';
import LocationReducer from './LocationReducer';
import OffSiteReducer from './OffSiteReducer';
import MoveReducer from './MoveReducer';
import RuralTrailersReducer from './RuralTrailersReducer';
import CorrectionReducer from './CorrectionReducer';
import WorkSheetReducer from './WorkSheetReducer';
import DepartmentReducer from './DepartmentReducer';
import NotificationReducer from './NotificationReducer';

//Combine all the sub reducers

const appReducer = combineReducers({
  /* your app’s top-level reducers */
  login: LoginReducer,
  trailerManagement: TrailerManagementReducer,
  userManagement: UserManagementReducer,
  doors: DoorReducer,
  division: DivisionReducer,
  lots: LotReducer,
  driver: DriverReducer,
  truck: TruckReducer,
  location: LocationReducer,
  OffSite: OffSiteReducer,
  move: MoveReducer,
  ruralTrailer: RuralTrailersReducer,
  correction: CorrectionReducer,
  workSheet: WorkSheetReducer,
  department: DepartmentReducer,
  notification: NotificationReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}
export { rootReducer }